<template>
  <main class="py-8 px-2 md:px-4">
    <h3>{{ $t("calendar.title") }}</h3>
    <Agenda v-model:formVisible="formVisible">
      <template #header>
        <div
          class="flex md:flex-row gap-3 items-center justify-between mt-6 flex-col px-2 w-full"
          v-role="['TEACHER', 'ADMINISTRATOR', 'APPLICATION_ADMIN']"
        >
          <div class="flex flex-col sm:flex-row md:items-center w-full gap-3">
            <div class="flex flex-row items-center gap-1">
              <v-icon name="co-filter" :scale="1.4" />
              <h6 class="w-full md:w-auto">
                {{ $t("calendar.visualize.label") }}
              </h6>
            </div>
            <div class="flex flex-col sm:flex-row gap-2 w-full md:w-auto">
              <Dropdown
                v-model="selectedCourse.id"
                :options="courses"
                optionLabel="name"
                optionValue="id"
                @change="onSelectCourse"
                :placeholder="
                  $t('calendar.visualize.autocomplete.course.placeholder')
                "
                @clear="clearInputCourse"
                filter
                @filter="searchByCourseName"
                showClear
                :filterPlaceholder="
                  $t('labels.generic', {
                    pt: 'Pesquisar curso',
                    en: 'Search course',
                  })
                "
                :emptyFilterMessage="
                  $t('labels.generic', {
                    pt: 'Nenhum curso encontrado',
                    en: 'No course found',
                  })
                "
                :emptyMessage="
                  $t('labels.generic', {
                    pt: 'Nenhum curso encontrado',
                    en: 'No course found',
                  })
                "
              />

              <Dropdown
                v-model="selectedClass.id"
                :options="classes"
                optionLabel="name"
                optionValue="id"
                @change="onSelectClass"
                :placeholder="
                  $t('calendar.visualize.autocomplete.class.placeholder')
                "
                @clear="clearInputClass"
                filter
                @filter="searchByClassName"
                showClear
                :filterPlaceholder="
                  $t('labels.generic', {
                    pt: 'Pesquisar turma',
                    en: 'Search class',
                  })
                "
                :emptyFilterMessage="
                  $t('labels.generic', {
                    pt: 'Nenhuma turma encontrada',
                    en: 'No class found',
                  })
                "
                :emptyMessage="
                  $t('labels.generic', {
                    pt: 'Nenhuma turma encontrada',
                    en: 'No class found',
                  })
                "
              />
            </div>
          </div>

          <Button
            icon="pi pi-plus"
            :label="$t('calendar.visualize.buttons.add')"
            class="btn btn-primary w-full md:w-[220px]"
            @click.prevent="addClass"
          />
        </div>
      </template>
    </Agenda>
  </main>
</template>
<script lang="ts">
import { Course } from "@/models/courses.model";
import { defineComponent } from "vue";
import { CalendarService } from "./calendar.service";
import { QueryParams } from "@/models/query-params.model";
import { computed } from "vue";
import { Classroom } from "@/models/classrooms.model";
import { getUserFromStorage } from "@/utils/user-store.util";

export default defineComponent({
  data() {
    return {
      selectedCourse: {} as Course,
      selectedClass: {} as Classroom,
      courses: [] as Array<Course>,
      courseParams: new QueryParams(),
      classes: [] as Array<Classroom>,
      classParams: new QueryParams(),
      formVisible: false,
    };
  },
  methods: {
    getCourses() {
      this.service.courses.subscribe({
        next: (response) => {
          this.courses = response.content;
          this.courseParams.size = response.size;
        },
      });
      this.service.getCourses(this.courseParams);
    },
    getClasses() {
      this.service.classes.subscribe({
        next: (response) => {
          this.classes = response.content;
          this.classParams.size = response.size;
        },
      });
      this.service.getClassrooms(this.classParams);
    },
    searchByCourseName(inputCourse: { value: string }) {
      this.courseParams.name = inputCourse.value;
      this.getCourses();
    },
    searchByClassName(inputCourse: { value: string }) {
      this.classParams.name = inputCourse.value;
      this.getClasses();
    },
    onSelectCourse(event: any) {
      Object.assign(this.selectedCourse, event.value);
    },
    onSelectClass(event: any) {
      Object.assign(this.selectedClass, event.value);
    },
    addClass() {
      this.formVisible = true;
    },
    clearInputCourse() {
      Object.assign(this.selectedCourse, new Course());
    },
    clearInputClass() {
      Object.assign(this.selectedClass, new Classroom());
    },
    setInitialData() {
      if (this.user?.role === "STUDENT") {
        this.selectedCourse.id = this.$route.params.id as string;
      } else {
        this.getCourses();
        this.getClasses();
      }
    },
  },
  computed: {
    service(): CalendarService {
      return new CalendarService();
    },
    user() {
      return getUserFromStorage();
    },
  },
  provide() {
    return {
      selectedCourseId: computed(() => this.selectedCourse.id),
      selectedClassId: computed(() => this.selectedClass.id),
    };
  },
  mounted() {
    this.setInitialData();
  },
});
</script>
<style lang="scss">
.custom-calendar {
  display: inherit;
  .p-button {
    @apply bg-h-primary-500 border border-h-primary-500;
  }
}
</style>
